export const locale = {
    lang: 'es',
    data: {
        'NAV': {
            'APPLICATIONS': 'Aplicaciones',
            'SAMPLE'        : {
                'TITLE': 'Ejemplo',
                'BADGE': '25'
            }
        }
    }
};
